import React from "react";
import { Line } from "react-chartjs-2";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Legend,
} from "chart.js";

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Legend);

function LineChart(props) {
  const chartOptions = {
    maintainAspectRatio: false, // Disable maintaining aspect ratio
    responsive: true,
    scales: {
      y: {
        beginAtZero: true,
      },
    },
    plugins: {
      legend: {
        display: false,
        labels: {
          boxWidth: 12,
          boxHeight: 12,
          color: "#222",
          Align: "center",
        },
      },
    },
  };
  return (
    <div
      className="chart-container"
      style={{ width: props.width, height: props.height }}
    >
      <Line
        data={{ ...props.data, labels: props.data.lineChartlabels }}
        options={chartOptions}
      />
    </div>
  );
}
export default LineChart;
